const ConversationView = () =>
  import(
    /* webpackChunkName: "Conversations" */ 'src/components/Dashboard/Views/Conversations/ConversationView.vue'
  );

export const conversationRoutes = [
  {
    path: 'conversations',
    name: 'Conversations',
    component: ConversationView,
    props: route => ({
      // followup: route.query.followup === 'true',
      querySort: route.query.sort,
      queryAssignee: route.query.assignee ? parseInt(route.query.assignee) : undefined,
      // queryAgentId: route.query.agentId ? Array.isArray(route.query.agentId) ? route.query.agentId.map(a => parseInt(a)) : [parseInt(route.query.agentId)] : undefined,
      queryDateStart: route.query.dateStart ? new Date(route.query.dateStart) : undefined,
      queryDateEnd: route.query.dateEnd ? new Date(route.query.dateEnd) : undefined,
      // Lead status is either a string if one, or an array if more than one.
      // vue-router is supposed to send an array always but it does not
      querySort: route.query.sort,
      queryPriority: route.query.priority ? parseInt(route.query.priority) : undefined,
      queryIncomplete: route.query.incomplete === 'true',
      queryUnassigned: route.query.unassigned === 'true',
      // queryTagIds: route.query.tags ? Array.isArray(route.query.tags) ? route.query.tags.map(t => parseInt(t)) : [parseInt(route.query.tags)] : undefined,
    })
  }
];
